import {get} from 'lodash';

import {FILTERS, RECORDS_FILTERS} from '/enum/filter.enum';

export function getDefaultRecordsFilter({recordsName}: any) {
  return get(FILTERS, get(RECORDS_FILTERS, [recordsName, 'default']));
}

export function getFilterOptions({recordsName}: any) {
  return get(RECORDS_FILTERS, [recordsName, 'items']);
}

export const getDefaultNewCoachesKey = (ffTeamsOrgSr: boolean) =>
  ffTeamsOrgSr ? 'Any time' : 'All Coaches';

export const getDefaultNewCoachesValue = (ffTeamsOrgSr: boolean) =>
  ffTeamsOrgSr ? 'any' : 'all';
